/**
 * L'état d'interface de « Ma journée » : le rappel mensuel de « Ma dispo ». Pur, testé.
 *
 * Les deux autres boîtes de l'accueil (`<TutorHomePage>`) vivent ailleurs : celle d'une séance qui
 * porte déjà une demande dans `useTutorSessionNotice` (la même que la semaine des lives), « Nouveau
 * mois » dans le store (`shouldShowResetModal`).
 */
export type TutorHomeUiState = {
    availabilityReminder: boolean
}

export type TutorHomeUiAction = { type: "OPEN_REMINDER" } | { type: "CLOSE_REMINDER" }

export const initialTutorHomeUiState: TutorHomeUiState = { availabilityReminder: false }

export function tutorHomeUiReducer(state: TutorHomeUiState, action: TutorHomeUiAction): TutorHomeUiState {
    switch (action.type) {
        case "OPEN_REMINDER":
            return state.availabilityReminder ? state : { ...state, availabilityReminder: true }
        case "CLOSE_REMINDER":
            return state.availabilityReminder ? { ...state, availabilityReminder: false } : state
    }
}
